<template>
    <div class="echart-chart-block">
        <!-- 分析報告 顯示氣象站最大最小值的特殊圖表 -->
        <div :id="chartID" :class="( dataZoom ? 'chart-tall' : 'chart' )"></div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import echarts from 'echarts'
import ecTools from '@/echarts/echarts-tools'

export default {
    props:
    {
        chartID: {
            type: String,
            required: true,
        },
        info_type: {
            type: String,
            default: 'realtime',
        },
        dataDisplaySettings: {
            type: Array,
            default: function () { return [] }
        },
        dataList: {
            type: Object,
            default: function () { return {} }
        },
        time: {
            type: Array,
            default: function () { return [] }
        },
        chartTitle: {
            type: String,
            default: '',
        },
        showToolbox: {
            type: Boolean,
            default: true,
        },
        xAxisFormat: {
            type: String,
            default: 'MM/DD',
        },
        xAxisName: { type: String, },
        yAxisName: { type: String, },
        dataZoom: {
            type: Boolean,
            default: false,
        },
        showDeviceName: {
            type: Boolean,
            default: true,
        },
        rightToolbox: {
            type: Boolean,
            default: true,
        },
    },
    data () {
        return {
            theChart: undefined,
            dataDisplay: [],
            // screenWidth: document.body.clientWidth,  // 視窗大小初始值
        }
    },
    mounted ()
    {
        this.theChart = echarts.init(document.getElementById( this.chartID ));
        this.drawChartPrepare();

        // 監聽視窗大小變化
        // const that = this
        // window.onresize = () => {
        //     return (() => {
        //         window.screenWidth = document.body.clientWidth
        //         that.screenWidth = window.screenWidth
        //     })()
        // }
    },
    computed: {
        ...mapState({
            'language': state => state.user.language,
            'screenWidth': state => state.system.screenWidth,
            'contentWidth': state => state.system.contentWidth,
        }),
    },
    watch: {
        // 偵測到 [ 語言 ] 變動就更新圖表
        language ()
        {
            this.drawChartPrepare();
        },

        // 偵測到 [ 時間 ] 變動就更新圖表
        time ()
        {
            this.drawChartPrepare();
        },

        // 偵測到 [ 資料 ] 變動就更新圖表
        dataList ()
        {
            this.drawChartPrepare();
        },

        // 偵測到 [ 標準 ] 變動就更新圖表
        standard ()
        {
            this.drawChartPrepare();
        },

        // 偵測到 [ 視窗寬度 ] 變動就更新圖表
        screenWidth (val, oldVal)
        {
            if ( val != oldVal && this.theChart != undefined )
            {
                this.theChart.resize()
            }
        },
        // 偵測到 [ 版面寬度 ] 變動就更新圖表
        contentWidth (val, oldVal)
        {
            if ( val != oldVal && this.theChart != undefined )
            {
                this.theChart.resize()
            }
        },
    },
    methods: {

        drawChartPrepare ()
        {
            // if (this.data && this.data.length > 0) {

                this.drawChart( this.theChart,
                                this.dataDisplaySettings,
                                this.dataList,
                                this.time,
                                this.showToolbox,
                                [ this.xAxisName, this.yAxisName ] );
            // }
        },
        
        drawChart ( chart,
                    _dataDisplaySettings,
                    _dataList,
                    _dataTime,
                    _showToolbox,
                    _axisName )
        {
            let _i18n_sensor = this.$t('sensor');
            let _legendTitle = [];
            let _series = [];
            let _yAxis = [];
            let _xAxisName = ( _axisName[0] ? this.$t('u.'+_axisName[0]) : '');
            let _xData = ecTools.get_XAxis_day( _dataTime.length, _dataTime, this.xAxisFormat );
            // 檢查視窗大小，顯示/隱藏項目
            let _chartWidth = chart.getWidth();
            let _firstData = undefined;
            let _shadowData = [ {}, {} ];
            let _colorUsed = [];
            let _rightBounding = [ 99999, -99999 ];
            // console.log( _xData )

            // 理論上只會有三個資料要畫
            _dataDisplaySettings.forEach( (_renderSettings, _idx) => {
                
                let _setting = ecTools.getSensorSettings( _renderSettings.param_name )
                
                if ( _i18n_sensor[ 'u_' + _renderSettings.key ] != undefined )  { _renderSettings.unit = _i18n_sensor[ 'u_' + _renderSettings.key ]; }
                else                                                            { _renderSettings.unit = _i18n_sensor[ 'u_' + _renderSettings.param_name ]; }
                
                _renderSettings.show_data_name = ( _i18n_sensor[ _renderSettings.data_name ] != undefined ? _i18n_sensor[ _renderSettings.data_name ] : _renderSettings.data_name )
                // 根據 this.showDeviceName 決定是否顯示裝置名稱
                _renderSettings.title = ( this.showDeviceName ? _renderSettings.device_name + ' ' : '' ) + _renderSettings.show_data_name;
                _renderSettings.precision = _setting.precision;


                _renderSettings.y_name = _renderSettings.unit;
                _renderSettings.y_bounding = ( _setting.bounding != undefined ? _setting.bounding.slice() : [ 99999, -99999 ] );
                _renderSettings.y_bounding_limit = ( _setting.bounding_limit != undefined ? _setting.bounding_limit.slice() : [ undefined, undefined ] );

                
                let _data_Line = ( _dataList[ _renderSettings.key ] ? _dataList[ _renderSettings.key ].slice() : [] );
                for (let i=0; i<_data_Line.length; i++)
                {
                    _data_Line[i] = ecTools.checkDataBounding( _data_Line[i], _renderSettings.y_bounding, _renderSettings.y_bounding_limit, _renderSettings.precision );
                }
                _renderSettings.data = _data_Line;

                // 左邊的 bounding 根據第一筆數值判斷；右邊的 bounding 已全部的數值來調整
                if ( _rightBounding[0] > _renderSettings.y_bounding[0] ) _rightBounding[0] = _renderSettings.y_bounding[0]
                if ( _rightBounding[1] < _renderSettings.y_bounding[1] ) _rightBounding[1] = _renderSettings.y_bounding[1]


                let _bShowPoint = false, _bShowAverage = false;
                let _color = ecTools.chart_HeatMap_Color[ _setting.color ]

                //  避免選到重複顏色
                if ( _colorUsed.indexOf( _color ) == -1 )
                {
                    _colorUsed.push( _color )
                }
                // else
                // {
                //     _color = ecTools.chart_HeatMap_Color['compare'][ _idx - 1 ]
                // }

                if (_idx == 0)
                {
                    _bShowPoint = true
                    _bShowAverage = false
                    _firstData = _renderSettings
                }
                
                _renderSettings.color = _color;
                _renderSettings.colorRGBA = ecTools.getColor_RGB( _color[1] );
                
                let _series_setting = {}
                if ( _renderSettings.chart_type == 'bar' )
                {
                    _series_setting = ecTools.createDateBar( _legendTitle, _renderSettings.title, _color, _data_Line, false, _renderSettings.standard, _chartWidth );
                }
                else if ( _renderSettings.chart_type == 'line' )
                {
                    _series_setting = ecTools.create_DayLine( _legendTitle, _renderSettings.title, _color, _data_Line, _bShowPoint, _bShowAverage, _chartWidth );
                }
                else if ( _renderSettings.chart_type == 'line_area_min' )
                {
                    _series_setting = undefined
                    _shadowData[0] = { setting: _renderSettings, data: _data_Line }
                }
                else if ( _renderSettings.chart_type == 'line_area_max' )
                {
                    _series_setting = undefined
                    _shadowData[1] = { setting: _renderSettings, data: _data_Line }
                }
                // console.log( _series[0] )

                
                if ( _series_setting != undefined )
                {
                    // 標準/警示線 or 標準/警示區域
                    if (_renderSettings.standard != undefined)
                    {
                        if (_renderSettings.standard.warning_line != undefined)
                        {
                            ecTools.createMarkLine( _renderSettings.standard.warning_line, _series_setting.markLine.data, _renderSettings.y_bounding );
                        }
                        if (_renderSettings.standard.warning_area != undefined)
                        {
                            ecTools.createMarkArea( _renderSettings.standard.warning_area, _series_setting.markArea.data, _renderSettings.y_bounding, _data.length );
                        }
                    }

                    if (_idx < 2)
                    {
                        _series_setting.yAxisIndex = _idx

                        let _yAxis_setting = {
                            gridIndex: 0,
                            name: ecTools.show_chart_unit( _renderSettings.y_name ),
                            nameGap: 10,
                            min: ( _renderSettings.y_bounding[0] ) * 0.9, // 最小值不要貼邊
                            max: ( _renderSettings.y_bounding[1] ) * 1.1, // 最大值不要貼邊
                            splitArea: { show: false },
                            splitLine: {
                                show: ( _idx == 0 ? true : false ),
                            //     show: ( _series[0].markLine.data.length > 1 ? false : true ),
                            //     lineStyle: {
                            //         color: 'rgba(' + _renderSettings.colorRGBA[0] + ',' + _renderSettings.colorRGBA[1] + ',' + _renderSettings.colorRGBA[2] + ',0.2)',
                            //     }
                            },
                        }
                        _yAxis.push(_yAxis_setting)
                    }

                    if (_idx == 0) { _series_setting.yAxisIndex = 0 }
                    else           { _series_setting.yAxisIndex = 1 }

                    _series.push( _series_setting )
                }
            })

            if (_yAxis.length > 1)
            {
                _yAxis[1].min = _rightBounding[0]
                _yAxis[1].max = _rightBounding[1]
                _yAxis[1].name = this.$t('menu.value')
            }
            
            // 繪製最大最小值區域
            if ( _shadowData[0].data != undefined && _shadowData[1].data != undefined && _series.length > 0 )
            {
                let _series_main = _series.slice()
                let _new_shadow = []
                
                // 指定主顏色
                let _colorMain_RGB = ecTools.getColor_RGB( _colorUsed[0][1] );

                
                for (let i=0; i<_shadowData[0].data.length; i++)
                {
                    if (_shadowData[0].data[ i ] != undefined && _shadowData[1].data[ i ] != undefined)
                    {
                        _new_shadow.push( (_shadowData[1].data[ i ] - _shadowData[0].data[ i ]).toFixed( _shadowData[0].setting.precision ) )
                    }
                    else _new_shadow.push( null )
                }
                let _new_serious = [
                    {
                        // Min
                        name: _shadowData[0].setting.title,
                        type: 'line',
                        data: _shadowData[0].data,
                        lineStyle: {
                            normal: {
                                opacity: 0,
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: _colorUsed[0][0]
                            }
                        },
                        stack: true,
                        symbol: 'none'
                    },
                    {
                        // Max
                        name: _shadowData[1].setting.title,
                        type: 'line',
                        data: _new_shadow,
                        lineStyle: {
                            normal: {
                                opacity: 0
                            }
                        },
                        areaStyle: {
                            normal: {
                                color: `rgba(${ _colorMain_RGB[0] },${ _colorMain_RGB[1] },${ _colorMain_RGB[2] },${ 0.4 })`
                                // color: 'rgba(255, 77, 77, 0.3)'
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: _colorUsed[0][2]
                            }
                        },
                        stack: true,
                        symbol: 'none'
                    },
                ]

                // 不可更改 push 順序，因為會影響 stack 的值
                _series_main.forEach( _ser => {
                    _new_serious.push( _ser )
                })
                _series = _new_serious
            }


            
            let option = {
                legend:
                {
                    y: '2%',
                    //right: 120,
                    data: _legendTitle
                },
                toolbox: ecTools.createToolbox( this.chartID, this.chartTitle, _showToolbox, this.rightToolbox ),
                tooltip:
                {
                    trigger: 'axis',//'item',
                    formatter: function (params) {
                        // console.log(params);
                        let _tooltip = params[0].name;

                        params.forEach(function (p) {
                            let _u = _dataDisplaySettings[ p.seriesIndex ].unit;

                            let _reference_value = p.value
                            if ( _shadowData[ p.seriesIndex ] && _shadowData[ p.seriesIndex ].data.length > 0 )
                            {
                                _reference_value = _shadowData[ p.seriesIndex ].data[ p.dataIndex ]
                            }
                            let _value = ( _reference_value != undefined ? _reference_value : '---' )
                            // console.log( p )

                            _tooltip += '<br><i class="fa fa-circle" style="color:'+ p.color +';"></i> ' + p.seriesName + ': ' + _value + ' ' + _u;
                        });
                        
                        return _tooltip;
                    }
                },
                dataZoom:
                [
                    {
                        show: this.dataZoom,
                        realtime: true,
                        // start: 30,
                        // end: 70,
                    },
                    {
                        disabled: ( ! this.dataZoom ),
                        type: 'inside',
                        realtime: true,
                        // start: 30,
                        // end: 70,
                    }
                ],
                grid:
                [{
                    id: 0,
                    x: ecTools.getGrid_x( _firstData.y_bounding[1], _firstData.precision, _chartWidth ),//'5%',
                    //y: -30,
                    top: '22%',
                    bottom: '18%',
                    width: ecTools.getGrid_width( _firstData.y_bounding[1], _firstData.precision, _chartWidth ),
                }],
                xAxis:
                [{
                    gridIndex: 0,
                    type: 'category',
                    name: _xAxisName,
                    nameGap: 25,
                    nameLocation: 'center',
                    data: _xData,
                    boundaryGap: true,
                    splitArea: { show: false },
                    splitLine: { show: false },
                }],
                yAxis: _yAxis,
                series: _series,
                animation: true,
            };

            chart.setOption(option);
        },

    }
    
}
</script>

<style lang="scss" scoped>



</style>
